import * as React from 'react'
import { memo } from 'react'
const SvgUpload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 13.176 16"
  >
    <path d="M3.765 12.235h5.647V6.588h3.765L6.589 0 .003 6.588h3.765ZM.003 14.117h13.174v1.882H.003Z" />
  </svg>
)
const Memo = memo(SvgUpload)
export default Memo
